<template>
    <div>
      <h2>Vue demo</h2>
    </div>
</template>

<script>
export default {
    name: 'Banner',
    data() {
        return{

        }
    },
}
</script>

<style>
    
</style>